import React, { useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { useParams } from "react-router-dom";
import walletsApi from "@api/wallets";
import CustomInput from "./CustomInput";
import { MarketContext } from "@context/MarketContext";
import { getMarketPairDisplay } from "@core/utils/getCurrencyMeta";

const LimitOrder = ({ type }) => {
  const classes = useStyles();
  const { currencyName } = useParams();
  const market = useContext(MarketContext);
  const { quoteName, baseUnit, quoteUnit } = getMarketPairDisplay(currencyName);
  const [state, setState] = useState({
    SellInventory: 0,
    BuyInventory: 0,
  });

  useEffect(() => {
    walletsApi
      .getMyWalletByCurrency({
        params: {
          currencyName: quoteUnit,
        },
      })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          BuyInventory: data.content.availableBalance,
        }));
      })
      .catch((data) => {});

    walletsApi
      .getMyWalletByCurrency({
        params: {
          currencyName: baseUnit,
        },
      })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          SellInventory: data.content.availableBalance,
        }));
      })
      .catch((data) => {});
  }, [currencyName, market.forceUpdate, baseUnit, quoteUnit]);

  const checkType = (type) => {
    switch (type) {
      case "buy": {
        return (
          <CustomInput
            type="buy"
            currencyUnitName={quoteName}
            currencyName={currencyName}
            FirstCurrencyUnit={baseUnit}
            SecondCurrencyUnit={quoteUnit}
            walletInventory={state.BuyInventory}
          />
        );
      }

      case "sell": {
        return (
          <CustomInput
            type="sell"
            currencyUnitName={quoteName}
            currencyName={currencyName}
            FirstCurrencyUnit={baseUnit}
            SecondCurrencyUnit={quoteUnit}
            walletInventory={state.SellInventory}
          />
        );
      }
    }
  };
  return <div className={classes.container}>{checkType(type)}</div>;
};

export default LimitOrder;
